import styled from '@emotion/styled';

const Elem:React.FC<any> = ({ children }) => {
  return (
    <Contianer>
      <Img src="/images/coupon_applied.svg"/>
    </Contianer>
  )
};

export default Elem;

const Contianer = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 7px;
  display: flex;
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
`